function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var camelCase = require("lodash.camelcase");
var _require = require("../utils/case-converter"),
  snakeCase = _require.snakeCase;
var isObject = function isObject(val) {
  if (val && _typeof(val) === "object" && !Array.isArray(val) && !(val instanceof Date)) return true;
  return false;
};

/**
 * To Lower case object keys recursively
 * @param {Object} objectToCon
 */
module.exports.toLowerKeys = function (objectToCon) {
  function recursive(obj) {
    var res = {};
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var keyLower = key.toLowerCase();
      if (isObject(obj[key])) {
        res[keyLower] = recursive(obj[key]);
      } else if (Array.isArray(obj[key])) {
        res[keyLower] = obj[key].map(function (item) {
          if (Array.isArray(item)) return item.map(function (el) {
            return isObject(el) ? recursive(el) : el;
          });
          return isObject(item) ? recursive(item) : item;
        });
      } else {
        res[keyLower] = obj[key];
      }
    }
    return res;
  }
  if (Array.isArray(objectToCon)) {
    return objectToCon.map(function (item) {
      return isObject(item) ? recursive(item) : item;
    });
  }
  return recursive(objectToCon);
};

/**
 * Upper case object keys recursively
 * @param {Object} objectToCon
 */
module.exports.toUpperKeys = function (objectToCon) {
  function recursive(obj) {
    var res = {};
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var keyUpper = key.toUpperCase();
      if (isObject(obj[key])) {
        res[keyUpper] = recursive(obj[key]);
      } else if (Array.isArray(obj[key])) {
        res[keyUpper] = obj[key].map(function (item) {
          if (Array.isArray(item)) return item.map(function (el) {
            return isObject(el) ? recursive(el) : el;
          });
          return isObject(item) ? recursive(item) : item;
        });
      } else {
        res[keyUpper] = obj[key];
      }
    }
    return res;
  }
  if (Array.isArray(objectToCon)) {
    return objectToCon.map(function (item) {
      return isObject(item) ? recursive(item) : item;
    });
  }
  return recursive(objectToCon);
};

/**
 * Camel case object keys recursively
 * @param {Object} objectToCon
 */
module.exports.toCamelKeys = function (objectToCon) {
  function recursive(obj) {
    var res = {};
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var keyCamel = camelCase(key);
      if (isObject(obj[key])) {
        res[keyCamel] = recursive(obj[key]);
      } else if (Array.isArray(obj[key])) {
        res[keyCamel] = obj[key].map(function (item) {
          if (Array.isArray(item)) return item.map(function (el) {
            return isObject(el) ? recursive(el) : el;
          });
          return isObject(item) ? recursive(item) : item;
        });
      } else {
        res[keyCamel] = obj[key];
      }
    }
    return res;
  }
  if (Array.isArray(objectToCon)) {
    return objectToCon.map(function (item) {
      return isObject(item) ? recursive(item) : item;
    });
  }
  return recursive(objectToCon);
};

/**
 * Snake case object keys recursively
 * @param {Object} objectToCon
 */
module.exports.toSnakeKeys = function (objectToCon) {
  function recursive(obj) {
    var res = {};
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var keySnake = snakeCase(key);
      if (isObject(obj[key])) {
        res[keySnake] = recursive(obj[key]);
      } else if (Array.isArray(obj[key])) {
        res[keySnake] = obj[key].map(function (item) {
          if (Array.isArray(item)) return item.map(function (el) {
            return isObject(el) ? recursive(el) : el;
          });
          return isObject(item) ? recursive(item) : item;
        });
      } else {
        res[keySnake] = obj[key];
      }
    }
    return res;
  }
  if (Array.isArray(objectToCon)) {
    return objectToCon.map(function (item) {
      return isObject(item) ? recursive(item) : item;
    });
  }
  return recursive(objectToCon);
};

/**
 * Change object keys name  recursively
 * @param {Object} objectToCon
 * @param {Object} changedKeys
 */
module.exports.changeKeys = function (objectToCon, changedKeys) {
  function recursive(obj) {
    var res = {};
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var newKey = changedKeys[key] == undefined ? key : changedKeys[key];
      if (isObject(obj[key])) {
        res[newKey] = recursive(obj[key]);
      } else if (Array.isArray(obj[key])) {
        res[newKey] = obj[key].map(function (item) {
          if (Array.isArray(item)) return item.map(function (el) {
            return isObject(el) ? recursive(el) : el;
          });
          return isObject(item) ? recursive(item) : item;
        });
      } else {
        res[newKey] = obj[key];
      }
    }
    return res;
  }
  if (Array.isArray(objectToCon)) {
    return objectToCon.map(function (item) {
      return isObject(item) ? recursive(item) : item;
    });
  }
  return recursive(objectToCon);
};

/**
 * String case conversion
 * 
 */
module.exports.toSnakeCase = function (key) {
  return snakeCase(key);
};
module.exports.toCamelCase = function (key) {
  return camelCase(key);
};